// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_av-0";
export var orangeButton = "_av-1";